export default __webpack_public_path__ + "static/media/devorange.b5b080e6.webp";